<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('details_frund_g') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-16 d-flex align-items-center">
							<span v-for="item in peopleList" v-if="item.id == detailsData.size">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
						</label>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-16 d-flex align-items-center">
							<span v-for="item in peopleList" v-if="item.id == detailsData.material">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
						</label>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-16 d-flex align-items-center">
							<span v-for="item in peopleList" v-if="item.id == detailsData.designer">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
						</label>
					</div>
				</div>

				
							
			</div>

			<div v-show="!isDetailsActive">
			
				<div class="form-group mb-3">
					<div class="form-row">
						<div class="col-12">
							<app-input v-model="detailsData.size"
							           :error-message="$errorMessage(errors, 'size')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
							</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<div class="col-12">
							<app-input v-model="detailsData.material"
							           :error-message="$errorMessage(errors, 'material')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
							</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<div class="col-12">
							<app-input v-model="detailsData.designer"
							           :error-message="$errorMessage(errors, 'designer')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
							</div>
					</div>
				</div>
				
				
				
				

			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformationFrund",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			urlGenerator,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
			storageList: [
	  		 		{ id: "1", name: "Склад", },
				  	{ id: "2", name: "Организация", },
					{ id: "3", name: "Персона", },
	  		],
			countryList: [],
			CondList: [
	  		 	{ id: "1", name: "1",},
				{ id: "2", name: "2",},
				{ id: "3", name: "3",},
				{ id: "4", name: "4",},
				{ id: "5", name: "5",},
				{ id: "6", name: "6",},
				{ id: "7", name: "7",},
				{ id: "8", name: "8",},
				{ id: "9", name: "9",},
				{ id: "10", name: "10",},

	  		],
			OwList: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
			errors: {}
		}
	},
	computed: {
		contentTypeList() {
			return this.$store.getters.contentType
		},
		idNew() {
			var number = this.detailsData.id;
			return ('00000' + number).slice(-5);
		},
		
		typeNew() {
			if(this.detailsData.contact_type.id == 3){
				return 'FN';
			} else if(this.detailsData.contact_type.id == 6){
				return 'A';
			} else if(this.detailsData.contact_type.id == 7){
				return 'WS';
			} else if(this.detailsData.contact_type.id == 8){
				return 'MS';
			} else if(this.detailsData.contact_type.id == 9){
				return 'J';
			} else if(this.detailsData.contact_type.id == 12){
				return 'AR';
			} else if(this.detailsData.contact_type.id == 13){
				return 'B';
			} else if(this.detailsData.contact_type.id == 14){
				return 'BR';
			} else if(this.detailsData.contact_type.id == 15){
				return 'BX';
			} else if(this.detailsData.contact_type.id == 16){
				return 'C';
			} else if(this.detailsData.contact_type.id == 17){
				return 'CD';
			} else if(this.detailsData.contact_type.id == 18){
				return 'F';
			} else if(this.detailsData.contact_type.id == 19){
				return 'FR';
			} else if(this.detailsData.contact_type.id == 20){
				return 'FRN';
			} else if(this.detailsData.contact_type.id == 21){
				return 'G';
			} else if(this.detailsData.contact_type.id == 22){
				return 'GL';
			} else if(this.detailsData.contact_type.id == 23){
				return 'HM';
			} else if(this.detailsData.contact_type.id == 24){
				return 'HW';
			} else if(this.detailsData.contact_type.id == 25){
				return 'HWR';
			} else if(this.detailsData.contact_type.id == 26){
				return 'J';
			} else if(this.detailsData.contact_type.id == 27){
				return 'JB';
			} else if(this.detailsData.contact_type.id == 28){
				return 'L';
			} else if(this.detailsData.contact_type.id == 29){
				return 'P';
			} else if(this.detailsData.contact_type.id == 30){
				return 'PB';
			} else if(this.detailsData.contact_type.id == 31){
				return 'S';
			} else if(this.detailsData.contact_type.id == 32){
				return 'SW';
			} else if(this.detailsData.contact_type.id == 33){
				return 'SM';
			} else if(this.detailsData.contact_type.id == 34){
				return 'TA';
			} else if(this.detailsData.contact_type.id == 35){
				return 'U';
			} else if(this.detailsData.contact_type.id == 36){
				return 'UF';
			} else if(this.detailsData.contact_type.id == 37){
				return 'UM';
			} else {
				return null;
			}
		},
		
		
		
		ownerList() {
			return this.$store.getters.getOwner
		},
		peopleList() {
			return this.$store.getters.getPerson
		},
		organizationList() {
			return this.$store.getters.getOrganization
		},
	},
	methods: {
		detailsInfoSync() {

			this.formData.name = this.detailsData.name;
			
			this.formData.year_on = this.detailsData.year_on;
			this.formData.year_off = this.detailsData.year_off;
			this.formData.cond = this.detailsData.cond;
			this.formData.country_made = this.detailsData.country_made;
			this.formData.country_buy = this.detailsData.country_buy;
			this.formData.storage = this.detailsData.storage;
			this.formData.type_owners = this.detailsData.type_owners;
			
			this.formData.date_buy = this.detailsData.date_buy ? moment(this.detailsData.date_buy).format(
        "YYYY-MM-DD"
      ) : null;

			
			this.formData.price_s = this.detailsData.price_s;
			this.formData.size = this.detailsData.size;
			this.formData.material = this.detailsData.material;
			this.formData.designer = this.detailsData.designer;
			this.formData.who = this.detailsData.who;
			this.formData.rest = this.detailsData.rest;
			this.formData.org = this.detailsData.org;
			
			
			this.formData.contact_type_id = this.detailsData.contact_type_id;
			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
		},
		detailsInfoEdit() {
			this.isDetailsActive = false
		},
		getAllCountrys() {
			this.axiosGet(`crm/country`).then(({data}) => {
				this.countryList = data;
			});
		}
		
	},
	created() {
		this.$store.dispatch('contentType');
		this.$store.dispatch('getOwner');
		this.$store.dispatch('getPerson');
		this.$store.dispatch('getOrganization');
		this.getAllCountrys();
	},
}
</script>

